export default __webpack_public_path__ + "static/media/pp-title-cn.f87d7ac9.webp";